import React from "react";

const ReportImage = React.memo(function ReportImage({
  src,
  alt = "",
  className = "",
}) {
  if (!src) return null;
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      loading="lazy"
      decoding="async"
    />
  );
});

export default ReportImage;
